import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { MetaProvider } from "./context/MetaContext";
import { ProtectedRoute } from "./components/ProtectedRoute";

import Login from "./pages/Login";
import Consulta from "./pages/Consulta";
import ProdutoDetalhe from "./pages/ProdutoDetalhe";
import Orcamento from "./pages/Orcamento";
import Orcamentos from "./pages/Orcamentos";
import Perfil from "./pages/Perfil";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProdutos from "./pages/admin/AdminProdutos";
import AdminImpostos from "./pages/admin/AdminImpostos";
import AdminNcms from "./pages/admin/AdminNcms";
import AdminImportacao from "./pages/admin/AdminImportacao";
import AdminUsuarios from "./pages/admin/AdminUsuarios";
import AdminCondicoes from "./pages/admin/AdminCondicoes";

const Privado = ({ children, adminOnly }) => (
  <ProtectedRoute adminOnly={adminOnly}>
    <MetaProvider>
      <CartProvider>{children}</CartProvider>
    </MetaProvider>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Navigate to="/consulta" replace />} />
            <Route
              path="/consulta"
              element={
                <Privado>
                  <Consulta />
                </Privado>
              }
            />
            <Route
              path="/produto/:id"
              element={
                <Privado>
                  <ProdutoDetalhe />
                </Privado>
              }
            />
            <Route
              path="/orcamento"
              element={
                <Privado>
                  <Orcamento />
                </Privado>
              }
            />
            <Route
              path="/orcamentos"
              element={
                <Privado>
                  <Orcamentos />
                </Privado>
              }
            />
            <Route
              path="/perfil"
              element={
                <Privado>
                  <Perfil />
                </Privado>
              }
            />
            <Route
              path="/admin"
              element={
                <Privado adminOnly>
                  <AdminDashboard />
                </Privado>
              }
            />
            <Route
              path="/admin/produtos"
              element={
                <Privado adminOnly>
                  <AdminProdutos />
                </Privado>
              }
            />
            <Route
              path="/admin/impostos"
              element={
                <Privado adminOnly>
                  <AdminImpostos />
                </Privado>
              }
            />
            <Route
              path="/admin/ncms"
              element={
                <Privado adminOnly>
                  <AdminNcms />
                </Privado>
              }
            />
            <Route
              path="/admin/importacao"
              element={
                <Privado adminOnly>
                  <AdminImportacao />
                </Privado>
              }
            />
            <Route
              path="/admin/condicoes"
              element={
                <Privado adminOnly>
                  <AdminCondicoes />
                </Privado>
              }
            />
            <Route
              path="/admin/usuarios"
              element={
                <Privado adminOnly>
                  <AdminUsuarios />
                </Privado>
              }
            />
            <Route path="*" element={<Navigate to="/consulta" replace />} />
          </Routes>
          <Toaster position="top-right" richColors closeButton />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
